import React from 'react';
import { Container } from '@material-ui/core';
import MaterialTable from 'material-table';

const data = [
    { id: 1, name: "Sunil", email:  'sunil@gmail.com', phone: 42566461, msg: "Hello,I am sunil" },
    { id: 2, name: "Vikas", email: 'vikas@gmail.com', phone: 5046531453, msg: "Hello,I am vikas"},
    { id: 3, name: "Ram", email: 'ram@gmail.com', phone: 60564654, msg: "Hey, I am Ram"},
    { id: 4, name: "Manish", email: 'manish@gmail.com', phone: 205454154, msg: "Hey, I am Manish" },
  ]

const Enquiry=()=>{

    
  const columns = [
    { title: "ID", field: "id", editable: false },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    { title: "Phone", field: 'phone', },
    { title: "MSG", field: "msg", }
  ]

    return(
        <Container maxWidth="md" fixed>
             <MaterialTable
        title="Enquiry"
        data={data}
        columns={columns}
        />
        </Container>
    )
}
export default Enquiry;
